'use strict';

/*jshint esversion: 6 */

function sameWidth(selector) {
	var width = 0;
	var maxWidth = void 0,
	    result = void 0;
	jQuery(selector).each(function () {
		result = jQuery(this);
		// If the height is greater than the last checked value
		if (result.outerWidth() > width) {
			// Set the height we'll use to the greater value
			maxWidth = this;
			width = result.outerWidth();
		}
	});

	// apply the width to each result
	jQuery(selector).css('width', width);
}

jQuery(window).on('load', function () {
	var imgRight = jQuery('.card .content.image-right');
	var imgLeft = jQuery('.card .content.image-left');

	jQuery(imgRight).each(function () {
		sameWidth(jQuery('.btn', this));
	});

	jQuery(imgLeft).each(function () {
		sameWidth(jQuery('.btn', this));
	});
});